import React from 'react';
var ExactaTableContext = React.createContext(null);
export var ExactaTableContextProvider = ExactaTableContext.Provider;
export var ExactaTableContextConsumer = ExactaTableContext.Consumer;
export default ExactaTableContext;
//# sourceMappingURL=ExactaTableContext.js.map